import React from "react";

const Categories = [
  {
    icon: "/img/marker-extremely-high.png",
    label: "Extremely High",
    description: ">= %95"
  },
  {
    icon: "/img/marker-very-high.png",
    label: "Very High",
    description: "%75 - %95"
  },
  {
    icon: "/img/marker-high.png",
    label: "High",
    description: "%50 - %75"
  },
  {
    icon: "/img/marker-medium.png",
    label: "Medium",
    description: "%25 - %50"
  },
  {
    icon: "/img/marker-low.png",
    label: "Low",
    description: "<= %25"
  },
  {
    icon: "/img/marker-not-defined.png",
    label: "No Data",
    description: "N/A"
  }
];

const MapKey = () => {
  return (
    <div
      className="position-absolute layer-overlay p-2 d-flex flex-column text-white"
      style={{ right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.6)" }}
    >
      <div className="text-center p-1">System Performance</div>
      {Categories.map((c, i) => (
        <div
          key={i}
          className="d-flex flex-row align-items-stretch justify-content-start p-1"
        >
          <div className="mr-1">
            <img className="h-100 p-2" src={c.icon} />
          </div>
          <div className="flex-grow-1 text-center">
            {c.label}
            <br />
            <small>{c.description}</small>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MapKey;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolMap/MapKey.js